// @flow
import type {Node} from 'react';
import type {Member} from 'api/v2';
import {Icon, IconNames, GridActionsCellItem} from '@wellstone-solutions/web';
import {LoadingIndicator} from 'components/shared/LoadingIndicator';
import {useCreateDocumentation} from 'modules/documentation/hooks';
import {useFeatureFlag, LD_FLAGS} from 'modules/feature-flags';

type PropsType = {member: Member, showInMenu: boolean};

export const CreateDocumentation = ({member, showInMenu}: PropsType): Node => {
  const {createDocumentation, isLoading} = useCreateDocumentation();
  const hasPeersDocumentation = useFeatureFlag(LD_FLAGS.PEERS_DOCUMENTATION);

  if (!hasPeersDocumentation) {
    return null;
  }

  const handleCreateDocumentation = () => {
    createDocumentation({memberId: member.id});
  };

  return (
    <GridActionsCellItem
      label="Create Documentation"
      key="createDocumentation"
      showInMenu={showInMenu}
      disabled={isLoading}
      icon={
        isLoading ? (
          <LoadingIndicator
            size={22}
            stylesOverride={{marginBottom: 0}}
            color="inherit"
          />
        ) : (
          <Icon name={IconNames.SubmitDocument} size={22} />
        )
      }
      onClick={(e) => {
        // $FlowIgnore - wrong type in Common Libs
        e.stopPropagation();
        handleCreateDocumentation();
      }}
    />
  );
};
